// Per-user release flag (merged plan + subscription features, the same list
// `useHasFeature` reads). Granted from /admin/users.
export const AI_ASSISTANT_FEATURE = 'ai_assistant';

export function hasAiAssistantFeature(features: ReadonlyArray<string | null> | null | undefined): boolean {
  return Array.isArray(features) && features.includes(AI_ASSISTANT_FEATURE);
}
